import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ResumeHemodialisaSvc from "@/services/ResumeHemodialisa";

@Module({ store, dynamic: true, namespaced: true, name: "resume-hemodialisa" })
class ResumeHemodialisaModule extends VuexModule {
  item: any | null = null;
  loading = false;

  @Mutation SET_ITEM(val: any | null) {
    this.item = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await ResumeHemodialisaSvc.getByRegister(reg);
      this.SET_ITEM(dt.data?.data || null);
    } catch {
      this.SET_ITEM(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEM(null);
  }
}

export const storeResumeHemodialisa = getModule(ResumeHemodialisaModule);
